import type { GetUploadUrlResponseBody } from '@common/interfaces/api/assetsApi';
import { fetchJson } from '@frontend/store/fetch';

const baseUrl = '/api/assets';

export async function getUploadUrl(contentType: string, signal: AbortSignal): Promise<GetUploadUrlResponseBody> {
    const url = `${baseUrl}/uploadurl?contentType=${contentType}`;
    const response = await fetchJson({ method: 'GET', signal, url });

    return response.json;
}

type UploadAssetWithProgressResult = {
    abort: () => void;
    uploadCompletedPromise: Promise<void>;
};

export function uploadAssetWithProgress(
    url: string,
    file: File,
    progressCallback: (uploadProgressPercentage: number) => void
): UploadAssetWithProgressResult {
    const request = new XMLHttpRequest();

    request.open('PUT', url);
    request.setRequestHeader('Content-Type', file.type);

    request.addEventListener('error', () => {
        throw new Error('Error in upload');
    });

    request.upload.addEventListener('progress', (event) => {
        const uploadProgressPercentage = Math.floor((100 * event.loaded) / event.total);
        progressCallback(uploadProgressPercentage);
    });

    request.send(file);

    return {
        abort: request.abort.bind(request),
        uploadCompletedPromise: new Promise((resolve) => {
            request.addEventListener('load', () => resolve());
        }),
    };
}
